// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__18R1W","search":"Settings_search__2LoZU","filter":"Settings_filter__3xni5"};